import verticalRacks from '../assets/farm/vertical-racks.jpg';
import hydroChannels from '../assets/farm/hydroponic-channels.jpg';
import harvestHandover from '../assets/farm/harvest-handover.jpg';
import harvestBasket from '../assets/farm/harvest-basket.jpg';
import harvestDinner from '../assets/farm/harvest-dinner.jpg';
import farmTour from '../assets/farm/farm-tour.jpg';
import workshop from '../assets/farm/workshop.jpg';
import stepHarvest from '../assets/farm/step-harvest.jpg';
import stepProduce from '../assets/farm/step-produce.jpg';
import stepDelivery from '../assets/farm/step-delivery.jpg';
import hydroBays from '../assets/tech/hydroponic-bays.jpg';
import controlledEnv from '../assets/tech/controlled-environment.jpg';

export const contact = {
  phone: '+91-9001924233',
  phoneHref: 'tel:+919001924233',
  email: 'contact@annpriya.com',
  emailHref: 'mailto:contact@annpriya.com',
  address: 'Annpriya Greenhouse, Jaipur, Rajasthan, India',
  linkedin: 'https://www.linkedin.com/company/annpriyaorganics/',
  facebook: 'https://www.facebook.com/profile.php?id=61580906127881',
  instagram: 'https://www.instagram.com/annpriyaorganics/',
};

export const navItems = [
  { name: 'Home', path: '/' },
  {
    name: 'Farm Tech',
    path: '/farm-tech',
    dropdown: [
      { name: 'Growing Methods', path: '/farm-tech', blurb: 'Vertical, hydroponic, aeroponic' },
      { name: 'The System', path: '/farm-tech/system', blurb: 'Six layers, one job each' },
      { name: 'Architecture', path: '/farm-tech/architecture', blurb: 'Layer by layer' },
      { name: 'Decision & Dosing', path: '/farm-tech/dosing', blurb: 'How a dose is computed' },
      { name: 'Safety & Actuation', path: '/farm-tech/safety', blurb: 'How a dose is authorised' },
      { name: 'Guarantees', path: '/farm-tech/components', blurb: 'What each layer promises' },
    ],
  },
  { name: 'About', path: '/about' },
  { name: 'Membership', path: '/membership' },
  { name: 'Sustainability', path: '/sustainability' },
  { name: 'Experiences', path: '/experiences' },
  { name: 'Contact', path: '/contact' },
];

export const footerNav = [
  {
    heading: 'Farm Tech',
    links: [
      { name: 'Growing Methods', path: '/farm-tech' },
      { name: 'The System', path: '/farm-tech/system' },
      { name: 'Architecture', path: '/farm-tech/architecture' },
      { name: 'Decision & Dosing', path: '/farm-tech/dosing' },
      { name: 'Safety & Actuation', path: '/farm-tech/safety' },
      { name: 'Guarantees', path: '/farm-tech/components' },
    ],
  },
  {
    heading: 'The Farm',
    links: [
      { name: 'About Annpriya', path: '/about' },
      { name: 'Membership', path: '/membership' },
      { name: 'Sustainability', path: '/sustainability' },
      { name: 'Experiences', path: '/experiences' },
      { name: 'FAQ', path: '/faq' },
      { name: 'Contact', path: '/contact' },
    ],
  },
];

/* ---------- Headline numbers ---------- */
export const statistics = [
  { value: '0', unit: '%', label: 'Pesticides or chemicals' },
  { value: '90', unit: '%', label: 'Less water used' },
  { value: '100', unit: '%', label: 'Consistent quality, year-round' },
  { value: '6', unit: 'hr', label: 'Harvest to doorstep' },
];

/* ---------- What makes it different ---------- */
export const features = [
  {
    icon: 'droplet',
    title: 'Water-efficient and eco-friendly',
    description:
      'Hydroponic and aeroponic methods save millions of litres of water every year and eliminate chemical run-off into the soil.',
  },
  {
    icon: 'clock',
    title: 'Fresh within hours',
    description:
      'Unlike supermarket produce that spends days in transit, your food is picked, packed and delivered the same day.',
  },
  {
    icon: 'shield',
    title: '100% pesticide-free',
    description:
      'No harmful residues. Only nutrient-enriched water systems and controlled growing conditions.',
  },
  {
    icon: 'star',
    title: 'Exclusivity that protects quality',
    description:
      'We serve just 500 families, which keeps care and attention constant for every plant and every member.',
  },
];

/* ---------- Growing methods (Farm Tech hub) ---------- */
export const growingMethods = [
  {
    id: 'vertical',
    name: 'Vertical Farming',
    lead: 'Maximizing space, minimizing waste',
    image: verticalRacks,
    summary:
      'Crops grown in stacked layers rather than spread across fields, inside climate-controlled units.',
    how: [
      'Plants grow in trays stacked floor to ceiling inside climate-controlled units',
      'LED lights replicate natural sunlight with wavelengths optimised for photosynthesis',
      'Sensors track temperature, humidity and CO₂ levels',
    ],
    benefits: [
      'Space efficiency: more food in 15,000 sq ft than a traditional farm grows in 10 acres',
      'Consistent yields: every tray receives the same light and nutrients',
      'Zero soil dependency: nothing soil-borne ever reaches the roots',
    ],
    matters:
      'Vertical farming lets us guarantee year-round supply. Your lettuce does not stop growing because the season changed.',
  },
  {
    id: 'hydroponics',
    name: 'Hydroponics',
    lead: 'Food grown without soil',
    image: hydroChannels,
    summary:
      'The roots take everything they need from nutrient-rich circulating water, so there is nothing left for soil to do.',
    how: [
      'Roots are submerged in nutrient solutions',
      'Pumps circulate water continuously, keeping oxygenation steady',
      'Excess water is captured and recycled',
    ],
    benefits: [
      '90% less water than soil farming',
      'Faster growth: plants absorb nutrients directly, shortening growth cycles',
      'Cleaner produce: no soil means no grit and no soil-borne disease',
    ],
    matters:
      'Hydroponic produce is consistently crisp and nutrient-dense. Spinach, lettuce and cucumbers grown this way are fresher, sweeter and last longer in your fridge.',
  },
  {
    id: 'aeroponics',
    name: 'Aeroponics',
    lead: 'The future of farming',
    image: hydroBays,
    summary:
      'Farming at its most futuristic. Roots hang suspended in air rather than sitting in soil or water.',
    how: [
      'Roots hang freely in a controlled chamber',
      'Nutrient-rich mist is sprayed at timed intervals',
      'Sensors monitor root health and nutrient absorption',
    ],
    benefits: [
      'High nutrient density: roots absorb oxygen more efficiently, producing antioxidant-rich plants',
      'Resource conservation: uses even less water than hydroponics',
      'Disease resistance: eliminates soil-based pests and pathogens entirely',
    ],
    matters:
      'Aeroponically grown basil, mint and microgreens carry intensified flavour and higher nutritional value.',
  },
];

export const controlledEnvironment = {
  image: controlledEnv,
  intro: 'All three methods thrive inside the same controlled greenhouse envelope.',
  items: [
    { title: 'Climate control', body: 'Temperatures held within ideal ranges for plant growth, whatever the season outside.' },
    { title: 'LED lighting', body: 'Mimics natural sunlight while reducing energy use.' },
    { title: 'CO₂ optimization', body: 'Balanced levels accelerate photosynthesis.' },
    { title: 'AI monitoring', body: 'Sensors feed data into systems that adjust growing conditions in real time.' },
  ],
  close: 'This is what makes every harvest identical in quality: crisp, safe and nutrient-rich.',
};

/* ---------- How it reaches you ---------- */
export const processSteps = [
  {
    step: 'Grow',
    image: stepProduce,
    description:
      'Seeds are nurtured in monitored vertical stacks, roots misted with nutrient-rich solutions that raise antioxidant levels and natural taste.',
  },
  {
    step: 'Harvest',
    image: stepHarvest,
    description: 'Produce is hand-picked at peak ripeness: crisp, vibrant and alive with nutrients.',
  },
  {
    step: 'Deliver',
    image: stepDelivery,
    description:
      'Packed in eco-friendly cold-chain boxes, your weekly harvest reaches your doorstep, often within six hours of harvest.',
  },
];

/* ---------- Sustainability ---------- */
export const sustainabilityItems = [
  { title: 'Water conservation', description: 'Hydroponic methods save up to 90% of the water a conventional farm uses.' },
  { title: 'No soil degradation', description: 'Vertical growing removes the over-cultivation problem entirely.' },
  { title: 'Renewable energy', description: 'Solar integration is underway to power the greenhouses sustainably.' },
  { title: 'Zero waste commitment', description: 'Plant residues are composted straight back into the system.' },
];

/* ---------- Experiences ---------- */
export const experiences = [
  { title: 'Harvest Dinners', image: harvestDinner, description: 'Farm-to-table evenings with renowned chefs.' },
  { title: 'Farm Tours', image: farmTour, description: 'See your food growing, and meet the team behind it.' },
  { title: 'Workshops', image: workshop, description: 'Learn about hydroponics, nutrition and sustainable living.' },
];

/* ---------- Membership ---------- */
export const membership = {
  /* No figure on the page by design: the price is quoted in conversation. */
  access: 'By invitation',
  accessNote: 'Membership runs a year at a time. Pricing is discussed when you enquire.',
  boxImage: harvestBasket,
  handoverImage: harvestHandover,
  box: [
    'Crisp leafy greens: lettuce, spinach, kale',
    'Fresh herbs: basil, mint, coriander',
    'Fruiting vegetables: cherry tomatoes',
    'Nutrient-packed microgreens',
    'Rotating seasonal specials',
  ],
  included: [
    { title: 'Customization window', body: 'Members tailor the weekly box to family preferences, dietary needs and seasonal cravings.' },
    { title: 'Chef-designed recipe cards', body: 'Each delivery includes recipes curated by chefs and nutritionists.' },
    { title: 'Access to events & workshops', body: 'Invitations to harvest dinners, farm tours and wellness workshops.' },
  ],
  terms: [
    { title: 'Payment terms', body: 'Monthly, quarterly or annual, whichever suits the household.' },
    { title: 'Add-ons', body: 'Exotic herbs, edible flowers and rare greens available at premium pricing.' },
    { title: 'Guest access', body: 'Members can extend event invitations to friends and family at preferential rates.' },
  ],
};

/* ---------- FAQ ---------- */
export const faqs = [
  {
    category: 'Membership',
    items: [
      { q: 'What is Annpriya membership?', a: 'An exclusive farm-to-table subscription that connects your family directly to our greenhouse. Members receive weekly harvests of pesticide-free produce, access to farm experiences, and a place in a community limited to 500 families.' },
      { q: 'Why only 500 families?', a: 'Capping membership is what lets us guarantee same-day delivery, personal service and sustainable practice. Quality over quantity.' },
      { q: 'How long is membership valid?', a: 'Memberships are annual, and renewable based on member satisfaction and space availability.' },
      { q: 'What if I move cities?', a: 'We deliver within 150 km of Jaipur. Outside that radius you can pause your membership or transfer it to someone within the delivery zone.' },
    ],
  },
  {
    category: 'Produce & farming',
    items: [
      { q: 'What do you grow?', a: 'More than 50 varieties of greens, herbs and vegetables, including butterhead lettuce, arugula, baby spinach, kale, basil, mint, coriander, cherry tomatoes and microgreens.' },
      { q: 'Is your produce really pesticide-free?', a: 'Yes. Nothing is ever sprayed. Growing indoors without soil keeps pest pressure low, and a crop that does show infection is removed rather than treated.' },
      { q: 'Are hydroponic and aeroponic crops truly organic?', a: 'The traditional organic label is soil-based, but our methods align with organic principles: no pesticides, no chemicals, and complete sustainability.' },
      { q: 'Does LED light affect taste?', a: 'No. It improves photosynthesis efficiency, which keeps crops consistently flavourful.' },
    ],
  },
  {
    category: 'Technology',
    items: [
      { q: 'Does an AI decide what my food is fed?', a: 'No. A deterministic model and a rules engine compute every dose, and it then has to clear a gate that neither of them can influence before a valve opens. The assistant on the system can explain any decision, but it has no path to an actuator.' },
      { q: 'What happens if the internet goes down?', a: 'Nothing stops. Every safety-critical part of the system runs locally on the edge server. Connectivity is an additive overlay, not a dependency.' },
      { q: 'What happens if something fails mid-dose?', a: 'The controller integrates measured flow against the commanded volume. Zero flow or excess flow aborts immediately, and valves force-close on link loss, watchdog timeout or fault.' },
      { q: 'Are there risks with water-based systems?', a: 'We use filtered, purified water, and closed-loop systems prevent contamination and ensure food safety.' },
    ],
  },
];
